<template>
  <div class="template">
    <img src="@/assets/images/template/picc-icon.png">
    <div class="redline"></div>
    <div class="top-title">盗抢保障证明函</div>
    <div class="num-con">编号：<span class="num">{{showDate.saleslip.pnum}}</span></div>
    <table class="temTable" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td>
          <div class="p-content">
            兹证明<span class="key">“青岛鑫诚泰网络科技有限公司”</span>销售的
            <span class="key">车载定位终端</span>（下称该产品）
            已向中国人民财产保险股份有限公司武汉市分公司（下称该公司）投保产品责任保险，投保人与被保险人均为<span class="key">青岛鑫诚泰网络科技有限公司</span>，
            保险单号为 <span class="key">PZAH201942010000000036</span>， <!--PZAH201942010000000036-->
            保险合同中双方约定的保险期限、承保区域、保险责任、除外责任、赔偿处理、索赔材料的内容如下：
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">一.保险期限：</div>
          <div class="p-content">
            自保单生效之日起{{swapper(selectYear)}}年有效。在保险期限内，如发生车辆转让，原保险责任立即中止，且应立即通知本公司办理变更手续。变更手续办理的次日零时起，保险责任恢复，但原保单中止日期不变。保险责任中止期间本公司不负责赔偿。
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <span class="key">二.承保区域：</span>中华人民共和国境内(不含港、澳、台)
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">三.保险责任：</div>
          <div class="p-content">
            保险期限内，被保险机动车的下列损失和费用，保险人依照本保险合同的约定负责赔偿：
          </div>
          <div class="p-content">
            1、被保险机动车被盗抢、抢劫、抢夺，经出险当地县级以上公安刑侦部门立案证明，满60天未查明下落的全车损失；
          </div>
          <div class="p-content">
            2、被保险机动车全车被盗抢、抢劫、抢夺后，受到损坏或车上零部件、附属设备丢失需要修复的合理费用；
          </div>
          <div class="p-content">
            3、被保险机动车在被抢劫、抢夺过程中，受到损坏需要修复的合理费用。
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">四.除外责任：</div>
          <div class="p-content">
            除产品责任保险条款中所列的除外责任外，保险人对下列各项亦不负责赔偿：1、非全车遭受盗窃，仅车上零部件或附属设备被盗窃、被破坏；2、被他人诈骗造成全车或部分损失；3、车辆因被有关国家机关罚没、扣押；
            4、因民事、经济纠纷造成车辆被抢劫、抢夺；5、租赁车辆；6、被保险人及其车主的故意行为；7、因违反该产品使用说明书规定的操作规程或擅自拆卸等引起的损失；8、因未按时交纳移动通信费用或服务费用被停机，导致该设备无法正常工作的。
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">五.赔偿处理：</div>
          <div class="p-content">
            发生保险责任事故时，被保险人可以得到下列赔偿：
          </div>
          <div class="p-content">
            被保险机动车被盗窃、抢劫、抢夺，经出险当地县级以上公安刑侦部门立案证明，满60天未查明下落的，按车辆实际价值100%赔付；
          </div>
          <div class="p-content">
            被保险机动车被盗窃、抢劫、抢夺，受到损坏需要修复合理费用的80%赔付；
          </div>
          <div class="p-content">
            赔付限额最高为<span class="p-underline">{{showDate.saleslip.compensation}}</span>元。
          </div>
          <!-- <div class="p-content">
            注：折旧率为每月6%。，折旧按月计算，不足一个月部分不计折旧。
          </div>
          <div class="p-content">
            折旧金额=安装该产品时的新车购置价*安装该产品车辆使用月数*月折旧率。
          </div> -->
          <div class="p-content">
            特别声明：若安装该产品的车辆为金融机构贷款所购，未还清贷款时，同意优先向第一受益人<span class="p-underline">{{showDate.saleslip.firstbeneficiaryname}}</span>支付保险赔款。
          </div>
        </td>
      </tr>
      <tr>
        <td>
        <div class="key">六.索赔材料：</div>
        1、本保险证明函、购买及安装本产品凭证、交费凭证；2、被盗车辆的行驶证、车辆登记证、原始购车发票、购置税本、车辆购置税发票、
        原车所有钥匙、县级以上公安刑侦部门出具的盗窃案件证明，每缺少一项，增加1%免赔，
        3、机动车车辆保险单、出险通知书、权益转让书；4、保险人要求的其他相关材料
        </td>
      </tr>
      <tr>
        <td>
          保险人名称：中国人民财产保险股份有限公司武汉市分公司<br>
          签章：<br>
          保险人地址：武汉市汉口中山大道207-213号&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联系方式：027-83761047
        </td>
      </tr>
    </table>
    <div class="personal-title">车主信息</div>
    <table class="personal-table" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td width="130">车主姓名</td>
        <td colspan="2">{{showDate.saleslip.customername}}</td>
        <td width="130">证件号码</td>
        <td colspan="2">{{showDate.saleslip.certificatenum}}</td>
      </tr>
      <tr>
        <td>固定电话</td>
        <td colspan="2"></td>
        <td>移动电话</td>
        <td colspan="2">{{showDate.saleslip.phone}}</td>
      </tr>
      <tr>
        <td>联系地址</td>
        <td colspan="2">{{showDate.saleslip.address}}</td>
        <td>保费金额</td>
        <td colspan="2">{{showDate.saleslip.policyamount}}</td>
      </tr>
      <tr>
        <td>车牌号码</td>
        <td>{{showDate.saleslip.carnum}}</td>
        <td width="130">车架号</td>
        <td>{{showDate.saleslip.frame}}</td>
        <td width="130">车辆登记日期</td>
        <td>{{this.$formatTimeCN(showDate.saleslip.buytime, 'yyyy-MM-dd')}}</td>
      </tr>
      <tr>
        <td>发动机号</td>
        <td>{{showDate.saleslip.enginenum}}</td>
        <td>产品编号</td>
        <td>{{showDate.saleslip.devicenum}}</td>
        <td>安装日期</td>
        <td>{{this.$formatTimeCN(showDate.saleslip.installtime, 'yyyy-MM-dd')}}</td>
      </tr>
      <tr>
        <td>安装地点</td>
        <td colspan="3">{{showDate.saleslip.installaddress}}</td>
        <td>安装人员</td>
        <td>{{showDate.saleslip.installman}}</td>
      </tr>
    </table>
    <p class="tips">注：该产品安装之日起保修36个月，若产品在保修期间出现故障，用户未到指定部门维修服务，后果自负。</p>
    <p class="tips">产品销售公司：(签章)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;车主签名：</p>
    <p class="tips">有效期:{{getendTime($formatTimeCN2(showDate.saleslip.pstarttime))}}</p>
    <p class="tips">全国统一客服热线：4006601517</p>
    <img class="inis" src="@/assets/images/inis.png" alt="">
    <img class="inis2" src="@/assets/images/inis2.png" alt="">
  </div>
</template>

<script>
export default {
  props:['showDate','selectYear'],
  data () {
    return {
    }
  },
  mounted () {
    // this.ini ()
  },
  methods: {
    swapper(n) {
      switch(n) {
        case 1:
          return '壹';
        case 2:
          return '贰';
        case 3:
          return '叁';
        case 4:
          return '肆';
        case 5:
          return '伍';
      }
    },
    getendTime(str) {
      str = str.split("年");
      let tempdata = Number(str[0]);
      str[0] = tempdata += this.selectYear;
      return str.join("年");
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/template/m1.vue